(()=>{'use strict';
const init=()=>{
 const box=document.querySelector('[data-gf-inline-search]');if(!box)return;
 const field=box.querySelector('input[type=search]'), form=box.querySelector('form'),
 result=box.querySelector('[data-gf-search-results]'), content=box.querySelector('[data-gf-search-list]'),
 status=box.querySelector('[data-gf-search-status]');
 if(!field||!form||!result)return;
 let controller=null,delay=null,seq=0;
 const clean=()=>{content.replaceChildren();status.textContent='';result.hidden=true;field.setAttribute('aria-expanded','false')};
 const stop=()=>{clearTimeout(delay);if(controller)controller.abort();seq++};
 const text=(tag,cl,value)=>{const el=document.createElement(tag);if(cl)el.className=cl;el.textContent=value||'';return el};
 const safeUrl=(url)=>{try{const u=new URL(url,location.origin);return u.origin===location.origin&&/^https?:$/.test(u.protocol)?u.href:null}catch(_){return null}};
 const show=(payload)=>{
   content.replaceChildren();let total=0;
   for(const [type,label] of [['products','products'],['articles','articles'],['collections','collections'],['pages','pages']]){
     const items=payload?.[type]||[];
     if(!Array.isArray(items)||!items.length)continue;
     const group=text('div','gf-inline-search__group');
     group.append(text('h3','',box.dataset[label]||type));
     for(const item of items.slice(0,4)){
       const uri=safeUrl(item.url);if(!uri)continue;
       const a=text('a','gf-inline-search__row');a.href=uri;
       const imgSrc=item.featured_image?.url||item.featured_image?.src||item.image;
       if(typeof imgSrc==='string'){
        try{const u=new URL(imgSrc,location.origin);
         if((u.hostname==='cdn.shopify.com'||u.origin===location.origin)&&u.protocol==='https:'){
           const img=document.createElement('img');u.searchParams.set('width','100');
           img.src=u.href;img.width=39;img.height=46;img.alt='';img.loading='lazy';a.append(img);
         }
        }catch(_){}
       }
       a.append(text('span','gf-inline-search__name',item.title||''),text('span','gf-inline-search__arrow','↗'));
       group.append(a);total++;
     }
     if(group.children.length>1)content.append(group);
   }
   if(!total)status.textContent=box.dataset.empty||'';
   result.hidden=false;field.setAttribute('aria-expanded',total?'true':'false');
 };
 const load=async()=>{
   stop();const term=field.value.trim();if(term.length<2){clean();return}
   const req=++seq;controller=new AbortController();
   const url=new URL(box.dataset.endpoint,location.origin);
   url.searchParams.set('q',term);url.searchParams.set('resources[type]','product,article,collection,page');
   url.searchParams.set('resources[limit]','4');
   try{const res=await fetch(url,{signal:controller.signal,headers:{Accept:'application/json'}});
     if(!res.ok)throw new Error('search');
     const data=await res.json();
     if(req!==seq)return;
     show(data?.resources?.results||{});
   }catch(e){if(e.name==='AbortError'||req!==seq)return;clean()}
 };
 field.addEventListener('input',()=>{
   clearTimeout(delay);
   if(field.value.trim().length<2){stop();clean();return}
   delay=setTimeout(load,220);
 });
 form.addEventListener('submit',e=>{if(field.value.trim().length>=2){e.preventDefault();load()}});
 document.addEventListener('pointerdown',e=>{if(!box.contains(e.target))clean()});
 field.addEventListener('keydown',e=>{
   if(e.key==='Escape'){e.stopPropagation();clean();field.blur()}
   if(e.key==='ArrowDown'){const a=result.querySelector('a');if(a){e.preventDefault();a.focus()}}
 });
 result.addEventListener('keydown',e=>{if(e.key!=='ArrowDown'&&e.key!=='ArrowUp')return;
   const a=[...result.querySelectorAll('a')],i=a.indexOf(document.activeElement);
   if(i<0)return;e.preventDefault();(a[i+(e.key==='ArrowDown'?1:-1)]||field).focus();
 });
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();